import MicroModal from 'micromodal';  // es6 module
import jQuery from "jquery"; window.$ = window.jQuery = jQuery;
// import Map from './map';
import { CountUp } from './countup.js';  // es6 module



import 'bootstrap/js/dist/collapse';


MicroModal.init({
	awaitCloseAnimation: true,
	onShow: function(modal){
		if(modal.id === 'modal-1'){
			console.log('opened beratung form');
			window.lintrk('track', { conversion_id: 10851234 });
			ga('send', 'event', 'formular', 'beratung', 'geoeffnet');
		}
	}
});



const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

if(urlParams.get('modal') === 'service'){
	MicroModal.show('modal-2');
}
if(urlParams.get('modal') === 'beratung'){
	MicroModal.show('modal-1');
}




const countBoxes = document.querySelectorAll('.box__item__count__counter');

if(countBoxes.length){
	const easingFn = function (t, b, c, d) {
		var ts = (t /= d) * t;
		var tc = ts * t;
		return b + c * (tc * ts + -5 * ts * ts + 10 * tc + -10 * ts + 5 * t);
	}
	const countupOptions = {
		easingFn,
		separator: '.',
		decimal: ',',
		suffix: '+',
	};
	countBoxes.forEach((elem) => {
		const endVal = parseInt(elem.innerText);
		console.log(endVal);
		const counter = new CountUp(elem, endVal, countupOptions);
		counter.start();
	})
}


$(document).ready(function(){

	$( ".data-policy-settings" ).bind( "click", function(e) {
		e.preventDefault();
		UC_UI.showSecondLayer();
	});


	function getRealValue($input){
		var value = $input.val() + ""; //string
		value = (value == null) ? "" : value;
		value = value.replace(/ /g, ''); // replace spaces
		return value;
	}

	var navOpen = false;

	$(".nav-trigger-wrapper, .dark-overlay").on("click", function(){
		$("body").toggleClass("nav-open");
	});

	function navParents(evt) {
	    var target = $(evt.target);
	    if (!target.parents('header').length) {
	    	if($("body").hasClass("search-open")){
	    		$("body").removeClass("search-open");
	    		$(document).off('click', navParents);
	    	}
	    }
	}

	var $input = $("input");

	if($input.length){
		$("form")
			.on("focusin", "input:not([type='checkbox']):not([type='submit']), textarea", function(){
				$(this).addClass("focused");
			})
			.on("focusout","input:not([type='checkbox']):not([type='submit']), textarea", function(){
				var $this = $(this);
				var value = getRealValue($this); // replace spaces

				if(value===""){
					$this.removeClass("focused");
				}

			});


		// detect browser autofill

		$("input[type='text'], input[type='email'], textarea").each(function(){
			var $this = $(this);

			if($this.val() != ""){
				$this.addClass("focused");
			}

			var style = $this.css('background-color'),
			inputBackgroundNormalState = 'rgb(255, 255, 255)';

			if(style !== inputBackgroundNormalState){
				$this.addClass("focused");
			}

		});

	}

});

import Swiper, {Navigation, Pagination, Autoplay, EffectFade} from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

if($('.swiper-container').length){

	var mySwiper = new Swiper('.swiper-container', {
		// Optional parameters.s
		preloadImages: false,
		simulateTouch: false,
		lazy: {
			loadPrevNext: true,
			loadPrevNextAmount: 10
		},
		slidesPerView: 'auto',
		breakpoints: {
			767 : {
				slidesPerView: 3,
			}
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},

		//spaceBetween: 30,

		// Navigation arrows
		//navigation: {
		//	nextEl: '.swiper-button-next',
		//	prevEl: '.swiper-button-prev',
		//},


	});

}

if($('.hero-slider').length){

	document.querySelectorAll('.hero-slider__container').forEach((element) => {

		const autoplay = parseInt(element.dataset.autoplay);
		let autoplayVal = false;

		if(autoplay > 0){
			autoplayVal = {delay: autoplay};
			console.log(autoplayVal);
		}

		var heroSlider = new Swiper(element, {
			// Optional parameters.s
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			autoplay: autoplayVal,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			speed: 1600
		});

	});

}


if($('.project-single-swiper-container').length) {

	var stlSingleSlider = new Swiper('.project-single-swiper-container', {
		simulateTouch: false,
		// If we need pagination
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true
		},


		// Navigation arrows
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},

	});

}


import Accordion from 'accordion-js';

document.querySelectorAll('.accordion-container').forEach((element) => {

	let showMultiple = element.getAttribute('data-show-multiple') !== 'false';
	let openOnInit = [];

	if(!showMultiple){
		openOnInit = [0];
	}

	new Accordion(element, {
		duration: 200,
		showMultiple: showMultiple,
		openOnInit: openOnInit
	});
});


// const mapElement = document.getElementById('map');
// if(mapElement){
// 	let map = new Map( latLng['lat'], latLng['lng']);
// 	map.init();
// }
//

//
// function initMap() {
// 	const germany = { lat: 51.2577161, lng: 10.2066518 };
// 	const map = new google.maps.Map(document.getElementById("map-places"), {
// 		zoom: 6,
// 		center: germany,
// 	});
// 	const infowindow = new google.maps.InfoWindow();
//
// 	let i;
//
// 	for (i = 0; i < prmPlaces.length; i++) {
//
// 		const marker = new google.maps.Marker({
// 			position: { lat : prmPlaces[i].lat, lng : prmPlaces[i].lng },
// 			map
// 		});
//
// 		const name = prmPlaces[i].name;
// 		const content = prmPlaces[i].content;
//
// 		marker.addListener("click", (i) => {
//
// 			infowindow.close();
// 			infowindow.setContent(
// 				`<div id="infowindow">
// 					<div class="h4">${name}</div>
// 					<p>${content}</p>
// 				</div>`);
// 			infowindow.open({
// 				anchor: marker,
// 				map,
// 				shouldFocus: false,
// 			});
// 		});
//
// 	}
// }
//
// if($('#map-places').length){
// 	initMap();
// }

// GA Click Events

$("a[href='tel:+4915144143471']").on("click", function () {
	ga('send', 'event', 'Button', 'click', 'Anruf Unverbindliche Beratung');
});





let swiperCategories = undefined;
let categorySwiperMobileInited = false;
const swiperCategoriesSelector = '.category-swiper-container';

const initCategorySwiper = () => {

	if($(swiperCategoriesSelector).length){

		const screenWidth = $(window).width();
		const BREAKPOINT = 575;

		if(screenWidth >= BREAKPOINT && swiperCategories === undefined) {
			swiperCategories = new Swiper(swiperCategoriesSelector, {
				simulateTouch: false,
				autoHeight: true,
				pagination: {
					el: '.swiper-pagination-custom--tab',
					clickable: true,
					type: 'bullets',
					bulletClass: 'tab',
					bulletActiveClass: 'current',
					renderBullet: function (index, className) {
						return `<a class='${className}'>${swiperCategoriesLabels[index]}</a>`;
					}
				},
			});
		} else if (screenWidth < BREAKPOINT && swiperCategories !== undefined) {
			swiperCategories.destroy();
			swiperCategories = undefined;
			$('.swiper-pagination-custom--tab').html('');
			initCategorySwiperMobile();
		} else if (screenWidth < BREAKPOINT && swiperCategories === undefined) { // not necessary but more readable
			initCategorySwiperMobile();
		}

	}
}

const initCategorySwiperMobile = () => {

	if(categorySwiperMobileInited){return;}

	$(swiperCategoriesSelector).find(".swiper-slide").each(function(index){
		$(this).wrap('<div class="collapse"></div>');
		$(`<div class='collapse-next collapse-trigger--menu'>${swiperCategoriesLabels[index]}</div>`).insertBefore($(this).parent());
		$(this).append('<div class="spacer-s"></div>');
	});

	categorySwiperMobileInited = true;

}

//Swiper plugin initialization
initCategorySwiper();

//Swiper plugin initialization on window resize
$(window).on('resize', function(){
	initCategorySwiper();
});

$('body').on('click', '.collapse-next, .collapse-arrow', function() {
	$(this).toggleClass('show').next().collapse('toggle');
	//swiperCategories.updateAutoHeight()
});



//Flyout Navigation
function owaNavigationFlyout() {
	var $nav = $("#menu-header-menue");
	if($nav.length){
		var lastOpen = false;
		var heightToBelowNavi = 0;

		$nav.find(" > li.menu-item-has-children").on("mouseenter", function(){

			if(lastOpen && typeof hideCurrent !== 'undefined'){
				clearTimeout(hideCurrent);
				lastOpen.removeClass("open");
			}

			var $this = $(this);
			$nav.addClass("js-hover");
			var $subMenu = $this.find("> .sub-menu-wrap");

			$subMenu.addClass("open");
			lastOpen = $subMenu;

			heightToBelowNavi = $subMenu.offset().top + $subMenu.outerHeight();

		}).on("mouseleave", function(event){

			if(event.clientY > heightToBelowNavi - 10){
				// if mouse Y coordinates are below the subnavi, hide immediately without delay
				// 10 = little extra buffer
				lastOpen.removeClass("open");
			} else {
				// user probably wants to reach another navpoint, add delay for crossmove access

				var hideCurrent = setTimeout(function(){
					lastOpen.removeClass("open");
				}, 300);
			}

		});
	}
}
owaNavigationFlyout();

function mobileNavigation(){

	const $window = $(window);
	const $submenuWrapper = $("nav .menu-item-has-children .sub-menu-wrap");
	let windowWidth = $window.width();

	if(windowWidth <= 575){
		$submenuWrapper
			.addClass('collapse')
			.prev()
			.on('click', function(e){
				e.preventDefault();
				$(this).toggleClass('show').next().collapse('toggle');
			});
	} else {
		$submenuWrapper
			.removeClass('collapse')
			.prev()
			.unbind('click');
	}

}

mobileNavigation();



